import {
  Environment,
  Network,
  RecordSource,
  Store
} from 'relay-runtime';
import getNetworkLayer from 'relay-mock-network-layer';

import schema from './schema_string';

// Make a GraphQL schema with no resolvers
//const schema = makeExecutableSchema({ typeDefs:graphql_schema });

export default mocks => {

  const network = Network.create(getNetworkLayer({
    schema,
    mocks
  }
  ));

  // Create an environment using this network:
  const store = new Store(new RecordSource());

  return new Environment({ network, store });

}
